import { ErrorHandler, inject } from "@angular/core";
import { createErrorHandler } from "@sentry/angular";
import { LocalRepository } from "@shared/helper/local-repository";

export class AppErrorHandler implements ErrorHandler {

    private sentryErrorHandler = createErrorHandler({ logErrors: true });
    private repo = inject(LocalRepository);

    handleError(error: any): void {

        const isChunkError = error?.message?.includes('Failed to load module') || error?.message?.includes('MIME type');

        if (isChunkError) {
            console.warn('Chunk load error detected, forcing reload');
            if (this.repo.IsInBrowser) {
                window.location.reload();
            }
            return;
        }

        this.sentryErrorHandler.handleError(error);
    }
}